export default __webpack_public_path__ + "static/media/01_Jelen_evropsky_lesni_Hanzak_upr.88bb912e.mp3";